"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.denormalize = void 0;

/**
 * A simple util to denormalize entities and ids into a single array
 * @param {string[]} ids The list of ids that serve as keys for entities
 * @param {object} entities Map of entity objects
 * @returns A denormalized array of entities containing the given ids
 */
var denormalize = function denormalize(ids, entities) {
  return ids.map(function (id) {
    return entities[id];
  });
};

exports.denormalize = denormalize;
//# sourceMappingURL=denormalize.js.map